<template>
  <div>
    <!-- Section qui contient l'image de l'Écolo-défi -->
    <!-- Activer cette section entre le 1er décembre et la dernière journée du Défi (environ mi-mars) -->
    <!--
                <div id="ecolo-defi"><a href="ecolo_defi.html"><img id="image_ecolo-defi" src="/images/ecolo-defi/fenetre195px.jpg" style="box-shadow:5px 5px 10px #959595" alt="" /></a></div>
                <div id="titre-fenetre">
                    <br/>
                    <a href="ecolo_defi.html" style="text-shadow:4px 4px 3px #c5c5c5;"><h3>L'Écolo-défi... de ma fenêtre</h3></a>
                    <br/>
                </div>
    -->

    <!-- Fin de la section qui contient l'image de l'Écolo-défi -->

    <!-- Section qui contient l'image de l'oiseau au-dessus des menus verticaux -->
    <!-- Activez cette section en dehors de la période de l'Écolo-défi -->

    <div id="oiseau_menus" v-if="homePageMenuPhoto && homePageMenuPhoto.display && homePageMenuPhoto.photo">
      <img
          :src="homePageMenuPhoto.photo.url"
          style="margin:15px 20px 0px; width: 80%; border-radius: 10px;"
          alt=""
      />
      <h3 class="birdNameMenu" v-if="homePageMenuPhoto.text">{{ homePageMenuPhoto.text }}</h3>
    </div>
    <!-- <div id="titre-oiseau-menus">
      <h3 class="birdNameMenu" style="margin:0px 0px 20px 55px">Petite nyctale</h3>
    </div> -->
    <br/>

    <!-- Fin de la section qui contient l'image de l'oiseau au-dessus des menus verticaux -->

    <div id="exemple5">
      <!-- Début des menus -->
      <ul id="menu5" class="side_menu">
        <li>
          <router-link class="collapsed" :to="{ name: 'HomePage' }">
            Accueil
          </router-link>
        </li>

        <li>
          <a class="collapsed">Qui sommes-nous ?</a>
          <ul>
            <li>
              <router-link :to="{ name: 'PresentationPage' }">
                Présentation du COQ
              </router-link>
            </li>
            <li class="active">
              <router-link :to="{ name: 'CaPage' }">Le CA</router-link>
            </li>
            <li class="active">
              <router-link :to="{ name: 'ResponsablesPage' }">
                Responsables / bénévoles
              </router-link>
            </li>
            <li class="active">
              <a href="/documents/territoire_coq_2012.jpg" target="_blank">
                Carte du territoire
              </a>
            </li>
          </ul>
        </li>

        <li>
          <a class="collapsed">Activités</a>
          <ul>
            <li>
              <router-link :to="{ name: 'ActivitesPage' }">
                Activités saisonnières
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'ConferencesPage' }" v-if="haveAnyConferencesToShow">
                Conférences
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'CoursInitPage' }">
                Cours d'ornithologie
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'AvicoursePage' }">
                Avicourse hivernale
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'EcoloDefiPage' }">
                Défi de ta fenêtre
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'Grand24Page' }">
                24 heures du COQ
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'RecensementNoelPage' }">
                Recensements des oiseaux de Noël
              </router-link>
            </li>
          </ul>
        </li>

        <li>
          <a class="collapsed">Observations</a>
          <ul>
            <li>
              <router-link :to="{ name: 'ObservationsOrniPage' }">
                Observations récentes
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'SoumissionObservationPage' }">
                Soumettre vos observations
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'ListesAnnoteesPage' }">
                Listes annotées
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'FaqPage' }">
                Foire aux questions
              </router-link>
            </li>
          </ul>
        </li>

        <li>
          <a class="collapsed">Liens</a>
          <ul>
            <li>
              <router-link :to="{ name: 'LiensClubsPage' }">
                Clubs d'ornithologie
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'LiensRessourcesPage' }">
                Ressources
              </router-link>
            </li>
            <li><a href="http://www.quebecoiseaux.org/" target="_blank">Regroupement QuébecOiseaux (RQO)</a>
            </li>
            <li>
              <router-link :to="{ name: 'photosMembresPage' }">
                Sites de photos d'oiseaux des membres
              </router-link>
            </li>
          </ul>
        </li>

        <li>
          <a class="collapsed">Documents officiels</a>
          <ul>
            <li>
              <router-link :to="{ name: 'DocumentsOfficielsPage' }">
                Procès-verbaux de l'AGA/Rapports annuels
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'DocumentsOfficielsPage' }">
                Mémoires
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'ReglementsPolitiquesPage' }">
                Règlements et politiques
              </router-link>
            </li>
          </ul>
        </li>

        <li>
          <a class="collapsed">Archives</a>
          <ul>
            <li>
              <router-link :to="{ name: 'Page60eme' }"
              >Le 60e du COQ
              </router-link
              >
            </li>
          </ul>
        </li>

        <li>
          <router-link class="collapsed" :to="{ name: 'CommanditairesPage' }"
          >Nos commanditaires
          </router-link
          >
        </li>

        <li>
          <router-link class="collapsed" :to="{ name: 'DevenirMembrePage' }">
            Devenir membre
          </router-link>
        </li>

        <li>
          <router-link class="collapsed" :to="{ name: 'PolitiqueConfidentialitePage' }">
            Politique de confidentialité
          </router-link>
        </li>

      </ul>
      <br/><br/>
    </div>
    <!-- Fin des menus -->
    
    


    <div>

      <div>
        <layout-sponsors/>
      </div>

      <!-- Section qui contient l'image d'un CD de photo -->
      <!-- Conserver cette section au cas où d'autres publicités seraient à insérer ici-->
      <!--
                  <div id="CD_Photos">
                      <a href="/documents/cd_photos_60e.pdf"><img src="/images/cd_photos.png" alt=""/></a>
                      <br/>
                      <a href="/documents/cd_photos_60e.pdf" style="text-shadow:4px 4px 3px #c5c5c5;"><h3>Procurez-vous votre copie<br/>du CD des photos du 60<sup>e</sup></h3></a>
                  </div>
        -->

      <!-- Section qui contient l'image de la prévente du 2e atlas -->

      <!-- <div id="Prevente 2e_Atlas">
        <a href="http://www.quebecoiseaux.org/atlas" target="_blank">
          <img
              src="/images/2e_Atlas-noel.jpg"
              style="float:left; margin-top:20px; height:174px; width:210px"
              alt=""
          />
        </a>
      </div> -->
    </div>
  </div>
  </div>
</template>

<script>
  import _ from 'lodash';
  import $ from 'jquery';
  import LayoutSponsors from './Partenaires';
  import { mapGetters } from 'vuex';

  export default {
    name: 'leftMenu',
    components: {
      LayoutSponsors
    },
    data() {
      return {
        slickOptions: {
          slidesToShow: 1
        }
      };
    },
    computed: {
      ...mapGetters('services', {
        _conferences: 'conferences'
      }),
      homePageMenuPhoto() {
        if (this.$store.state.config && this.$store.state.config.homePageMenuPhoto) {
          return this.$store.state.config.homePageMenuPhoto;
        }
        return null;
      },
      haveAnyConferencesToShow() {
        if (this._conferences) {
          return _.size(this._conferences.filter(c => c.show !== false)) > 0;
        }
        else {
          return false;
        }
      }
    },
    methods: {},
    mounted() {
      setTimeout(function() {
        // Accordion
        /* $('#menu5 > li > a').click(function() {
$(this).siblings().toggleClass('active-menu');
});*/

        $('#menu5 > li > a').click(function() {
          $(this)
            .siblings()
            .animate({ height: 'toggle' });
        });
      }, 250);
    }
  };
</script>

<style scoped lang="scss">
.side_menu ul {
  width: 100%;
}

.side_menu ul a {
  width: 97.5%;
  border: 1px solid rgba(103, 103, 106, 0.47) !important;
  border-top: 0 !important;
}

#oiseau_menus {
  text-align: right;
  width: 210px;
}

#menu5 > li {
  margin-bottom: 10px;
}
</style>
